import { Divider } from "@mui/material";
import { GroupChatListPanelHeaderWrapper } from "../group/patient/PatientChats.styles";
import { GroupChatListPanelHeader } from "../GroupChatListPanelHeader";
import { useContext } from "react";
import { HiddenChatsContext } from "hhn-commons";
import HiddenGroupChatList from "./HiddenGroupChatList";

type HiddenGroupChatListPanelProps = {
  unreadChatCount: number;
  selectedChatId?: string;
};

export const HiddenGroupChatListPanel = ({
  selectedChatId,
  unreadChatCount,
}: HiddenGroupChatListPanelProps) => {
  const { chatData, fetchChats, isChatLoading } =
    useContext(HiddenChatsContext);

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={unreadChatCount}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <HiddenGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
